import script from "./MyLeaderboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyLeaderboard.vue?vue&type=script&setup=true&lang=ts"

import "./MyLeaderboard.vue?vue&type=style&index=0&id=46809116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46809116"]])

export default __exports__